import React, { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import Price from '@components/ui/price/index';
import { Col, Separator } from '@components/formStyles';
import { TourLowestPrice } from '@api/index';
import DiscountLabel from '@components/ui/labels/discount/DiscountLabel';
import MilePriceBadge from '@uikit/milePriceBadge';
import { getCurrencySymbol } from '@utils/utils';

import {
  Title,
  Wrapper,
  RoutesInfoWrapper,
  RoutesInfo,
  RightCol,
  DiscountWrapper,
  StyledButton,
  CampaignLabelWrapper,
  RightWrapper,
  PriceDetails,
  FlexEnd,
  ReadMore,
  DynamicRow,
  TopWrapper,
} from './styled';
import { CardContainer as Container } from '../styled';
import { getDiscountType } from '../../helpers/getDiscountType';

export interface SummaryCardProps {
  onNavigate: () => void;
  onReadMore?: () => void;
  name: string;
  whereToGo?: string;
  description: string;
  prices?: TourLowestPrice;
  roomInformation?: string;
  isExpedia?: boolean;
  isTour?: boolean;
  tourType?: string;
  installments?: string;
  isEmpty?: boolean;
  toggleLetUsCallYou: () => void;
}

export const ReadMoreSection: FC<{ text: string; onClick?: () => void }> = ({
  text,
  onClick,
}) => <ReadMore onClick={onClick}>{text}</ReadMore>;

const SummaryCad: FC<SummaryCardProps> = ({
  onNavigate,
  onReadMore,
  name,
  description,
  prices,
  roomInformation,
  whereToGo,
  tourType,
  isEmpty,
  toggleLetUsCallYou,
}) => {
  const { xl } = useBreakpoint();

  return (
    <Container>
      <Wrapper>
        <TopWrapper>
          <DynamicRow alignItems='center'>
            <Col>
              <Title>{name}</Title>
            </Col>
          </DynamicRow>
        </TopWrapper>

        <RoutesInfoWrapper>
          <RoutesInfo isBold>Gezilecek Yerler</RoutesInfo>
          <RoutesInfo>{whereToGo}</RoutesInfo>
        </RoutesInfoWrapper>

        {description.length > 300 ? (
          <ReadMoreSection text='Devamını Oku' onClick={onReadMore} />
        ) : null}
      </Wrapper>
      {xl ? (
        <RightCol>
          <RightWrapper>
            <CampaignLabelWrapper>
              {/* <WorldLogo label={installments} /> */}
            </CampaignLabelWrapper>
            <Separator size='41px' />
            {prices?.price ? (
              <FlexEnd>
                {prices.discountRate ? (
                  <DiscountWrapper>
                    <DiscountLabel
                      discount={prices.discountRate}
                      type={getDiscountType(prices?.discountType)}
                      currency={prices.discountCurrency}
                    />
                  </DiscountWrapper>
                ) : null}

                {prices?.milePrice && (
                  <MilePriceBadge milePrice={prices?.milePrice} />
                )}

                <Price
                  originalPriceSize={16}
                  originalPriceCurrency={getCurrencySymbol(prices.currency)}
                  originalPrice={prices.price}
                  discountedPrice={prices.discountedPrice}
                  sellingPrice={
                    prices.discountRate
                      ? prices.tryDiscountedPrice
                      : prices.tryPrice
                  }
                  price={prices.tryDiscountedPrice}
                  isTour={true}
                  tourType={tourType}
                  horizontalAlign='flex-end'
                />

                <PriceDetails>'den başlayan fiyatlarla</PriceDetails>
                <PriceDetails isBold>{roomInformation}</PriceDetails>
              </FlexEnd>
            ) : null}
            <Separator />
            {isEmpty ? (
              <>
                <Separator size='70px' />
                <StyledButton onClick={toggleLetUsCallYou}>
                  Biz Sizi Arayalım
                </StyledButton>
              </>
            ) : (
              <StyledButton onClick={onNavigate}>Tarihleri İncele</StyledButton>
            )}{' '}
          </RightWrapper>
        </RightCol>
      ) : null}
    </Container>
  );
};

export default SummaryCad;
